import React from "react";
import { FaBolt, FaShieldAlt, FaHandHoldingUsd } from "react-icons/fa";

const PriorityStatus: React.FC = () => {
  return (
    <section className="w-full py-16 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { label: "Secured Data System", icon: <FaShieldAlt className="text-primary" />, value: "Protected" },
          { label: "Customized Loan Options", icon: <FaHandHoldingUsd className="text-primary" />, value: "Flexible" },
          { label: "Instant Approval Process", icon: <FaBolt className="text-primary" />, value: "Efficient" }
        ].map((item, i) => (
          <div key={i} className="flex items-center gap-6 p-8 bg-white border border-gray-100 rounded-[2rem] shadow-sm hover:shadow-md transition-shadow">
            <div className="w-16 h-16 rounded-2xl bg-blue-50 flex items-center justify-center text-3xl">{item.icon}</div>
            <div>
              <div className="text-xs font-bold text-text-secondary uppercase tracking-widest mb-1">{item.value}</div>
              <div className="text-lg font-extrabold text-text-primary leading-tight">{item.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PriorityStatus;
